function toMillis(value) {
  if (!value) return 0;
  if (typeof value === "number") return value;
  if (typeof value?.toMillis === "function") return value.toMillis();
  if (value?.seconds) return (value.seconds * 1000) + Math.floor((value.nanoseconds || 0) / 1e6);
  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : 0;
}

function clean(value) {
  return String(value || "").trim();
}

function actorName(item) {
  return clean(item?.userName) || clean(item?.posterName) || clean(item?.donorName) || "Someone";
}

function resolveUnit(item) {
  const unit = clean(item?.impactData?.unit);
  if (!unit) return "";
  if (unit.toLowerCase() === "kg") return "kg";
  return unit;
}

function resolveQuantity(item) {
  const candidates = [
    item?.impactData?.kgFood,
    item?.impactData?.amount,
    item?.impactData?.quantity,
    item?.impactData?.areaHectares,
  ];
  for (const c of candidates) {
    const n = Number(c);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return null;
}

function formatQuantityWithUnit(item) {
  const quantity = resolveQuantity(item);
  if (!Number.isFinite(quantity)) return "";
  const unit = resolveUnit(item);
  if (!unit) return String(quantity);
  return `${quantity}${unit.toLowerCase() === "kg" ? "kg" : ` ${unit}`}`;
}

export function formatImpactFeedText(item) {
  const type = clean(item?.type).toLowerCase();
  const action = clean(item?.action).toLowerCase();
  const who = actorName(item);
  const title =
    clean(item?.relatedProductName) ||
    clean(item?.impactData?.title) ||
    clean(item?.impactData?.crop) ||
    "";
  const qty = formatQuantityWithUnit(item);

  if (type === "product_listing" || action === "product_posted") {
    if (title) return `${who} posted a new product: ${title}`;
    return `${who} posted a new product`;
  }

  if (type === "price_contribution" || action === "price_report_validated") {
    const price = Number(item?.impactData?.price);
    const crop = clean(item?.impactData?.crop) || title;
    if (crop && Number.isFinite(price)) return `${who} reported a price update: ${crop} at ${price.toLocaleString("en-US")} RWF`;
    if (crop) return `${who} reported a price update for ${crop}`;
    return `${who} reported a price update`;
  }

  if (type === "planting_intention") {
    const crop = clean(item?.impactData?.crop) || title;
    const status = clean(item?.impactData?.status).replace(/_/g, " ");
    if (crop && status) return `${who} updated planting status: ${status} ${crop}`;
    if (crop) return `${who} shared a planting update for ${crop}`;
    return `${who} shared a planting update`;
  }

  if (type === "rating" || action === "product_rating_received") {
    const stars = Number(item?.impactData?.rating);
    if (Number.isFinite(stars) && stars > 0) return `${who} submitted a ${stars}-star rating`;
    return `${who} submitted a rating`;
  }

  if (title) return `${who} updated ${title}`;
  return `${who} completed a network action`;
}

export function formatImpactFeedTime(value) {
  const ts = toMillis(value);
  if (!ts) return "Now";
  return new Date(ts).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
}
